module.exports = __webpack_public_path__ + "img/product-3.4fe8513d.png";